import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { API, authHeaders, formatApiError } from "../../lib/api";

const inputCls =
  "w-full rounded-xl border border-[#DDD8C8] bg-white px-4 py-2.5 text-sm focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20";
const labelCls = "mb-1 block text-xs font-bold uppercase tracking-wider text-neutral-500";

export default function AccountTab() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("Las contraseñas nuevas no coinciden");
      return;
    }
    if (next.length < 8) {
      toast.error("La nueva contraseña debe tener al menos 8 caracteres");
      return;
    }
    setSaving(true);
    try {
      await axios.post(
        `${API}/auth/change-password`,
        { current_password: current, new_password: next },
        authHeaders()
      );
      toast.success("Contraseña actualizada correctamente");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="account-tab">
      <div className="mb-6">
        <h2 className="font-display text-xl font-bold text-neutral-900">Mi cuenta</h2>
        <p className="text-sm text-neutral-500">Cambie la contraseña de acceso al panel administrativo.</p>
      </div>
      <form
        onSubmit={submit}
        className="max-w-md space-y-4 rounded-2xl border border-[#E8E4D9] bg-white p-6 shadow-sm"
        data-testid="change-password-form"
      >
        <div>
          <label className={labelCls}>Contraseña actual *</label>
          <input
            type="password"
            required
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            className={inputCls}
            data-testid="current-password-input"
          />
        </div>
        <div>
          <label className={labelCls}>Nueva contraseña *</label>
          <input
            type="password"
            required
            value={next}
            onChange={(e) => setNext(e.target.value)}
            className={inputCls}
            data-testid="new-password-input"
          />
        </div>
        <div>
          <label className={labelCls}>Confirmar nueva contraseña *</label>
          <input
            type="password"
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className={inputCls}
            data-testid="confirm-password-input"
          />
        </div>
        <button
          type="submit"
          disabled={saving}
          data-testid="change-password-submit"
          className="flex w-full items-center justify-center gap-2 rounded-full bg-brand py-3.5 text-sm font-bold text-white hover:bg-brand-dark disabled:opacity-60"
        >
          <KeyRound size={15} /> {saving ? "Guardando…" : "Cambiar contraseña"}
        </button>
      </form>
    </div>
  );
}
